module.exports = __webpack_public_path__ + "img/target_icon04.9473fb12.png";